export default __webpack_public_path__ + "static/media/online_insurrance_bg.866938a0.svg";